export const addressView = (address: string): string => {
  return address.slice(0, 8) + '...' + address.slice(-10);
};
